import { createSlice } from '@reduxjs/toolkit';
import LOCALES from '../../constants/locales';

const initialState = {
  redirectUrl: '',
  selectedLocale: LOCALES.EN_IN,
};

const redirectUrlSlice = createSlice({
  name: 'redirect',
  initialState,
  reducers: {
    updateRedirectUrlData: (state, { payload }) => ({ ...state, redirectUrl: payload }),
    reset: () => initialState,
  },
});

export const {
  updateRedirectUrlData,
} = redirectUrlSlice.actions;

export default redirectUrlSlice.reducer;
